import React, { FC } from "react";
import MineTailingsInfoTabs from "./MineTailingsInfoTabs";

export const MineTailingsInfo: FC = () => <MineTailingsInfoTabs enabledTabs={["tsf"]} />;

export default MineTailingsInfo;
